const defaultSettings = {
  homeTitle: 'Les espaces d\'activités de la Région Sud',
};

const prefixFiltering = scope => (acc, curr) => {
  const [, prefix, key] = /(.{7})(.*)/.exec(curr) || [];
  return prefix === 'GATSBY_' ? { ...acc, [key]: scope[curr] } : acc;
};

/**
 * Generate injectedSettings from `window` variables prefixed by `GATSBY_`
 */
const injectedSettings = typeof window !== 'undefined'
  ? Object.getOwnPropertyNames(window).reduce(prefixFiltering(window), {})
  : {};

/**
 * Merge both objects
 */
export default {
  ...defaultSettings,
  ...injectedSettings,
};
